import { SEND_AGREEMENT_MAIL, SEND_AGREEMENT_MAIL_FAILED, SEND_AGREEMENT_MAIL_SUCCESS } from "store/NdaAgreement/Constants"
import { ADD_VEHICLE, ADD_VEHICLE_FAIL, ADD_VEHICLE_SUCCESS, APPROVE_VEHICLE_SUGGESTIONS, APPROVE_VEHICLE_SUGGESTIONS_FAIL, APPROVE_VEHICLE_SUGGESTIONS_SUCCESS, REJECT_VEHICLE_SUGGESTIONS, REJECT_VEHICLE_SUGGESTIONS_FAIL, REJECT_VEHICLE_SUGGESTIONS_SUCCESS, SEND_SUGGESTION_EMAIL, SEND_SUGGESTION_EMAIL_FAILED, SEND_SUGGESTION_EMAIL_SUCCESS, VIEW_VEHICLE_SUGGESTIONS, VIEW_VEHICLE_SUGGESTIONS_FAIL, VIEW_VEHICLE_SUGGESTIONS_SUCCESS, CHANGE_ACTION, CHANGE_ACTION_SUCCESS, CHANGE_ACTION_FAIL } from "./Constants"

export const viewVehicleSuggestions = () =>{
    return{
        type: VIEW_VEHICLE_SUGGESTIONS

    }
}

export const viewVehicleSuggestionsSuccess = (payload) =>{
    return {
        type: VIEW_VEHICLE_SUGGESTIONS_SUCCESS,
        payload
    }
}

export const viewVehicleSuggestionsFail = (payload) =>{
    return{
        type: VIEW_VEHICLE_SUGGESTIONS_FAIL,
        payload
    }
}

export const approveVehicleSuggetion = (payload) =>{
    return{
        type: APPROVE_VEHICLE_SUGGESTIONS,
        payload
    }
}

export const approveVehicleSuggetionSuccess = (payload) =>{
    return{
        type: APPROVE_VEHICLE_SUGGESTIONS_SUCCESS,
        payload
    }
}

export const approveVehicleSuggetionFail = (payload) =>{
    return{
        type: APPROVE_VEHICLE_SUGGESTIONS_FAIL,
        payload
    }
}

export const rejectVehicleSuggestion = (payload) =>{
    return{
        type: REJECT_VEHICLE_SUGGESTIONS,
        payload
    }
}

export const rejectVehicleSuggestionSuccess = (payload) =>{
    return{
        type: REJECT_VEHICLE_SUGGESTIONS_SUCCESS,
        payload
    }
}

export const rejectVehicleSuggestionFail = (payload) =>{
    return{
        type: REJECT_VEHICLE_SUGGESTIONS_FAIL,
        payload
    }
}

export const addVehicle = (payload) =>{
    return{
        type: ADD_VEHICLE,
        payload
    }
}

export const addVehicleSuccess = (payload) =>{
    return{
        type: ADD_VEHICLE_SUCCESS,
        payload
    }
}

export const addVehicleFail = (payload) =>{
    return{
        type: ADD_VEHICLE_FAIL,
        payload
    }
}


export const sendSuggestionEmail = (payload) =>({
    type: SEND_SUGGESTION_EMAIL,
    payload
})

export const sendSuggestionEmailSuccess = (payload) =>({
    type: SEND_SUGGESTION_EMAIL_SUCCESS,
    payload
})

export const sendSuggestionEmailFailed = (payload) =>({
    type: SEND_SUGGESTION_EMAIL_FAILED,
    payload
})

export const changeAction = (payload) =>({
    type: CHANGE_ACTION,
    payload
})

export const changeActionSuccess = (payload) =>({
    type: CHANGE_ACTION_SUCCESS,
    payload
})

export const changeActionFail = (payload) =>({
    type: CHANGE_ACTION_FAIL,
    payload
})